import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CurrentUserEffects } from './state/current-user.effects';
import * as FromCurrentUserReducer from './state/current-user.reducer';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature('current_user', FromCurrentUserReducer.currentUserReducer),
        EffectsModule.forFeature([CurrentUserEffects]),
    ],
})
export class CurrentUserModule {}
